// Format angka gaya Indonesia (1.250,5), rupiah, pecahan, dan jam.
import { r3, simp } from './math.js';

export const fmt=x=>r3(x).toLocaleString('id-ID',{maximumFractionDigits:3});
export const rp=x=>'Rp'+fmt(x)+',00';
export const F=(n,d)=>`<span class="fr"><span class="fn">${n}</span><span class="fd">${d}</span></span>`;
export const mix=(w,n,d)=>w>0?(n>0?`${w}&#8239;${F(n,d)}`:`${w}`):F(n,d);
export function FM(n,d){[n,d]=simp(n,d);if(d===1)return `${n}`;return mix(Math.floor(n/d),n%d,d);}
export const jam=m=>{m=((m%1440)+1440)%1440;return String(Math.floor(m/60)).padStart(2,'0')+'.'+String(m%60).padStart(2,'0');};
export const LET='ABCDEF';
export const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
export const fmtClock = ms => { const s = Math.floor(ms / 1000); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); };
export function fmtDur(ms) {
  const s = Math.round(ms / 1000);
  if (s < 60) return s + ' dtk';
  const m = Math.floor(s / 60);
  if (m < 60) return m + ' mnt ' + (s % 60) + ' dtk';
  return Math.floor(m / 60) + ' jam ' + (m % 60) + ' mnt';
}
